module.exports = __webpack_public_path__ + "static/img/hengrun-building.33736af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/hengrun-building.jpg
// module id = NasS
// module chunks = 1